// On /properties, Quick Email sits in the right tool column
// (.quick-email-wrapper). Work Orders opens in that same column and
// replaces whatever is already there, so Chat Bot can stay open beside it.
const PROPERTIES_RIGHT_COLUMN = ['showQuickEmail', 'showWorkOrders'];

function workOrderPanelClass(path) {
  if (path === '/main') {
    return 'work-orders-wrapper wrapper-absolute-position';
  }
  if (path === '/lease-search') {
    return 'work-orders-wrapper wrapper-absolute-position-2';
  }
  if (path === '/documents') {
    return 'work-orders-wrapper wrapper-absolute-position-3';
  }
  if (path === '/properties') {
    return 'work-orders-wrapper wrapper-properties-quick-email-column';
  }
  return 'chat-wrapper';
}

function rightColumnPanelFlags(path) {
  if (path === '/properties') return PROPERTIES_RIGHT_COLUMN.slice();
  return [];
}

function panelFlagsKeptOnClose(path) {
  return rightColumnPanelFlags(path);
}

function rightColumnOpenChanges(path, openingFlag) {
  const column = rightColumnPanelFlags(path);
  if (!column.includes(openingFlag)) return null;
  const changes = { [openingFlag]: true };
  for (const flag of column) {
    if (flag !== openingFlag) changes[flag] = false;
  }
  return changes;
}

// A saved layout can still have both right-column panels from before they
// shared a slot. Work Orders is the replacement, so it wins.
function exclusiveRightColumn(path, openKeys) {
  const keys = openKeys || [];
  const column = rightColumnPanelFlags(path);
  const present = column.filter((flag) => keys.includes(flag));
  if (present.length < 2) return keys.slice();
  const keep = present.includes('showWorkOrders')
    ? 'showWorkOrders'
    : present[present.length - 1];
  const drop = new Set(present.filter((flag) => flag !== keep));
  return keys.filter((flag) => !drop.has(flag));
}

module.exports = {
  workOrderPanelClass,
  rightColumnPanelFlags,
  panelFlagsKeptOnClose,
  rightColumnOpenChanges,
  exclusiveRightColumn,
};
